import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { GenericApiData } from "src/components/shared-components/class/general-classes/generic-api-data";
import { TranslationStoreAction } from "src/components/shared-components/enum/enumStoreAction";

/**
 * Reseet translation state and unset key storage
 */
export const translationUnsetKeyStorage = createAction(
  TranslationStoreAction.TRANSLATION_UNSET_KEY_STORAGE
);

/**
 * Action fired when request to load start
 */
export const translationLoadInitStartAction = createAction(
  TranslationStoreAction.TRANSLATION_LOAD_INIT_START
);

/**
 * Action to load full list of translation
 */
export const translationLoadListFromApiAction = createAction(
  TranslationStoreAction.TRANSLATION_LOAD_FROM_API
);

/**
 * Action to load last modified list of translation
 */
export const translationLoadLastModifiedFromApiAction = createAction(
  TranslationStoreAction.TRANSLATION_LOAD_LAST_MODIFIED_FROM_API,
  props<{ translationObject: GenericApiData }>()
);

/**
 * Action translation load success
 */
export const translationLoadSuccessAction = createAction(
  TranslationStoreAction.TRANSLATION_LOAD_SUCCESS,
  props<{ translationObject: GenericApiData }>()
);


/**
 * Action to populate the translations list with old, pre-existent data (after API error).
 */
export const translationPopulateWithOldDataAction = createAction(
  TranslationStoreAction.TRANSLATION_LOAD_OLD_DATA,
  props<{ oldTranslationObject: GenericApiData }>()
);

/**
 * Action to handle generic error in translations loading from API
 */
export const translationLoadErrorHandlingAction = createAction(
  TranslationStoreAction.TRANSLATION_LOAD_ERROR_HANDLING,
  props<{ error: HttpErrorResponse }>()
);

/**
 * Action translation load error
 */
export const translationLoadErrorAction = createAction(
  TranslationStoreAction.TRANSLATION_LOAD_ERROR
);

/**
 * Action to force reload translation
 */
export const translationForceReloadAction = createAction(
  TranslationStoreAction.TRANSLATION_FORCE_RELOAD
);
